import dyLoaded from './dy-loaded';
import trackEvent from './dy-track-event';

export default async function trackGender(gender) {
  try {
    await dyLoaded();
    const eventData = {
      gender: gender,
    };
    await trackEvent('Gender', eventData);
    return Promise.resolve();
  } catch (e) {
    console.error('Error tracking event: trackGender()', e);
    return Promise.reject(e);
  }
}
